import "./MenuVtc.css";
import { manualdownload } from "../../../Api/SubUrl";
import { Path } from "../../../Api/Path";
import useClientAuthSession from "../../../Hooks/useClientAuthSession";
function MenuVTC() {
    const { isAuthenticated } = useClientAuthSession();

  if (!isAuthenticated) return null;

  return (
    <div className="content-right">
      <div className="inner">
        <a
          href={manualdownload}
          className="download"
          aria-label="Tải xuống"
          rel="noopener noreferrer"
        ></a>

        <a
          href={Path.Fanpage}
          className="trade"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Giao dịch"
        ></a>

        <a
          href={Path.Fanpage}
          className="fanpage"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Fanpage"
        ></a>

        <a
          href={Path.Group}
          className="group"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Nhóm"
        ></a>

        <button
          type="button"
          className="totop"
          id="totop"
          aria-label="Lên đầu trang"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        ></button>
      </div>
    </div>
  );
}
export default MenuVTC;
